function game() {
  return globalThis.TTMinis?.game || null;
}

function normalizeQuery(raw) {
  if (!raw) return {};
  if (typeof raw === "string") return Object.fromEntries(new URLSearchParams(raw));
  if (typeof raw === "object") return raw;
  return {};
}

function shareCodeFromOptions(options) {
  const query = normalizeQuery(options?.query);
  return String(query?.shareCode || query?.share_code || "").trim();
}

function sdkCanUse(name) {
  const sdk = game();
  if (!sdk || typeof sdk[name] !== "function") return false;
  if (typeof sdk.canIUse !== "function") return true;
  try {
    return sdk.canIUse(name) !== false;
  } catch {
    return true;
  }
}

function invoke(name, options = {}) {
  const sdk = game();
  const fn = sdk?.[name];
  if (typeof fn !== "function") throw new Error(`TTMinis.game.${name} is unavailable`);

  return new Promise((resolve, reject) => {
    let settled = false;
    const success = value => {
      if (settled) return;
      settled = true;
      resolve(value || {});
    };
    const fail = error => {
      if (settled) return;
      settled = true;
      const message = error?.errMsg
        || error?.error?.error_msg
        || error?.message
        || error
        || "TikTok share failed";
      reject(error instanceof Error ? error : new Error(String(message)));
    };

    try {
      const result = fn.call(sdk, { ...options, success, fail });
      if (result?.then) result.then(success, fail);
    } catch (error) {
      fail(error);
    }
  });
}

export async function shareTikTokMap({ shareCode, title, subtitle = "", imageUrl = "" } = {}) {
  const code = String(shareCode || "").trim();
  if (!code || !sdkCanUse("shareAppMessage")) return null;

  const query = new URLSearchParams({
    shareCode: code,
    source: "workshop_share"
  }).toString();

  await invoke("shareAppMessage", {
    title: String(title || "BricksBeater Map"),
    subtitle: String(subtitle || ""),
    imageUrl: String(imageUrl || ""),
    query,
    templateType: 1
  });

  return { mode: "tiktok-dm", shareCode: code, query };
}

export function readTikTokShareCode() {
  const sdk = game();
  if (!sdk) return "";

  for (const getter of ["getEnterOptionsSync", "getLaunchOptionsSync"]) {
    if (typeof sdk[getter] !== "function") continue;
    try {
      const code = shareCodeFromOptions(sdk[getter]());
      if (code) return code;
    } catch {
      // Continue to the next lifecycle getter.
    }
  }
  return "";
}

export function installTikTokShareEntry(router) {
  const sdk = game();
  if (!sdk || !router) return () => {};
  let lastOpenedCode = "";

  const openCode = raw => {
    const code = String(raw || "").trim();
    if (!code || code === lastOpenedCode) return;
    lastOpenedCode = code;

    const current = router.currentRoute?.value;
    if (
      current?.name === "shared-map"
      && String(current.params?.shareCode || "") === code
    ) return;

    router.push({
      name: "shared-map",
      params: { shareCode: code }
    }).catch(() => {});
  };

  openCode(readTikTokShareCode());

  const onShow = result => {
    const code = shareCodeFromOptions(result);
    if (code) openCode(code);
  };

  if (typeof sdk.onShow === "function") {
    try { sdk.onShow(onShow); } catch { /* Browser/Preview fallback stays usable. */ }
  }

  return () => {
    if (typeof sdk.offShow === "function") {
      try { sdk.offShow(onShow); } catch { /* no-op */ }
    }
  };
}
